<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p>Rebecca was born in Australia and now lives in London with her husband and dogs and any combination of her three children (depending on who has decided to move in this week.) Rebecca spends her non-writing time singing, sailing, swimming, or walking the dogs. The rest of the time is spent sorting the family archives finding more inspiration for stories about every day, interesting people.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?b0a6e014